import { ArrowRight, Filter, Search, Calendar, Plus } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Link } from "react-router-dom";
import styles from "../expenseList.module.css";
import { useAuth0 } from "@auth0/auth0-react";
import FilterAutocomplete from "../../../../../../components/FilterAutocomplete";

const STATUS_OPTIONS = [
  { value: 1, label: "Due" },
  { value: 2, label: "Paid" },
  { value: 0, label: "Upcoming" },
];

const ListFilters = ({ setFilterData, setFilterOpen, filterOpen, filterData, selectProperty, propertyList, apartmentList, setCurrentFilterValue, expenseCategories, payeeList }) => {
  const { user, isAuthenticated } = useAuth0();

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" onChange={(e) => { setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; }); setCurrentFilterValue("search"); }} />
      </div>
    </div>

    <div className={`${styles.FilterSec}`}>
      <div className={filterOpen === true ? `${styles.FilterFieldSec} ${styles.Open}` : `${styles.FilterFieldSec}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setFilterOpen(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width220} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Property"
            options={propertyList}
            value={filterData?.property}
            onChange={(value) => {
              // The apartment filter belongs to the previous property, so clear it
              setFilterData((prev) => ({ ...prev, property: value, apartment: "" }));
              selectProperty(value);
              setCurrentFilterValue("property");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Payee"
            options={(payeeList || []).map((i) => ({ value: i.id, label: i.company_name }))}
            value={filterData?.payee}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, payee: value }));
              setCurrentFilterValue("payee");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Category"
            options={(expenseCategories || []).map((i) => ({ value: i.id, label: i.title }))}
            value={filterData?.category}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, category: value }));
              setCurrentFilterValue("category");
            }}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} ${styles.Width160} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Status"
            options={STATUS_OPTIONS}
            value={filterData?.status}
            onChange={(value) => {
              setFilterData((prev) => ({ ...prev, status: value }));
              setCurrentFilterValue("status");
            }}
          />
        </div>

        <div className={`${styles.FilterCard}`}>
          <div className={`${styles.DashFilterSec} DashFilterSec Filter`}>
            <DateRangePicker
              format={"MM/dd/yy"}
              placeholder={"Filter by date"}
              placement={"bottomEnd"}
              caretAs={Calendar}
              showOneCalendar
              onChange={(date) => {
                setFilterData((prev) => {
                  return { ...prev, due_date: date };
                });
                setCurrentFilterValue("due_date");
              }}
            />
          </div>
        </div>
      </div>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("expense:create") > -1 && <div className={`${styles.ListGridBUCard}`}>
        <Link to={"/expense/all-expense/add"} className={`${styles.AddNoteBu}`}>
          <Plus /> <span>New Expense</span>
        </Link>
      </div>}

      <Link className={`${styles.FilterBu}`} onClick={(e) => setFilterOpen(true)}>
        <Filter />
      </Link>
    </div>
  </div>);
};

export default ListFilters;